import React, { useRef, useState, useCallback, useEffect } from 'react';
import { Virtuoso } from 'react-virtuoso';
import { getApi } from '../funciones/sesion.js';
import logo from '../assets/img/logo.png'
import separador from '../assets/img/separador.png'

import { casaIc, medalla } from '../funciones/casas.js'


const styles = {
    container: {
        
        marginBottom: "50px",
        height: '100vh',
        overflowY: 'auto',
        perspective: '0px',
    },
    item: {
        padding: '20px',
        margin: '10px auto',
        borderRadius: '8px',
        willChange: 'transform, opacity',
        transition: 'transform 0.1s ease-out, opacity 0.1s ease-out',
        // Clave: El punto de origen para la rotación y el escalado
        transformOrigin: 'center center',
        maxWidth: '100%', // Para ver mejor la perspectiva
    }
};

const ScaleMenu3DComponent = () => {
    const [menuItems, setMenuItems] = useState();
    const listRef = useRef(null);
    const itemRefs = useRef({});
    const [isMounted, setIsMounted] = useState(false);



    const calculateTransformations = useCallback((container, element) => {
        if (!container || !element) return { scale: 1, rotateX: 0, opacity: 1 };

        const containerRect = container.getBoundingClientRect();
        const itemRect = element.getBoundingClientRect();

        // 1. Cálculo de Posición Normalizada (0 arriba, 1 abajo)
        const itemCenterY = (itemRect.top + itemRect.height) * 5 / 2;
        const relativeY = itemCenterY - containerRect.top;
        let normalizedY = relativeY / containerRect.height;

        // Clamping (asegurar que esté entre 0 y 1 para la interpolación)
        normalizedY = Math.max(0, Math.min(1, normalizedY));

        // 2. Interpolación de Propiedades (Ajusta estos valores para el look and feel)

        // A. Escala (va de pequeño a normal)
        const minScale = 0.10;
        const maxScale = 1;
        const scale = minScale + normalizedY * (maxScale - minScale);

        // B. Rotación (va de inclinado a plano)
        // MaxRotation: Máxima inclinación en grados (por ejemplo, 30 grados)
        const maxRotation = 10;
        // normalizedY=0 (arriba) -> 30 grados (más inclinado)
        // normalizedY=1 (abajo) -> 0 grados (plano)
        const rotateX = maxRotation * (1 - normalizedY);

        // C. Opacidad (va de transparente a opaco)
        const minOpacity = 1;
        const maxOpacity = 1;
        const opacity = minOpacity + normalizedY * (maxOpacity - minOpacity);

        // D. Traslación Z (opcional, para dar un efecto de acercamiento al centro)
        // normalizedY=0.5 (centro) -> translateZ(0)
        // normalizedY=0 (arriba) y 1 (abajo) -> translateZ(profundidad)
        const maxTranslateZ = -500; // Profundidad en píxeles
        const translateZ = maxTranslateZ * Math.abs(normalizedY - 0.5) * 5; // Va de -500 a 0 y viceversa

        return { scale, rotateX, opacity, translateZ };
    }, []);

    // 3. Función de Actualización
    const updateScales = useCallback(() => {
        const container = listRef.current?.firstChild;

        if (container) {
            Object.values(itemRefs.current).forEach(element => {
                if (element) {
                    const { scale, rotateX, opacity, translateZ } = calculateTransformations(container, element);

                    // Aplicar todas las transformaciones 
                    element.style.transform = `
                        scale(${scale}) 
                        rotateX(${rotateX}deg) 
                        translateZ(${translateZ}px)
                    `;
                    element.style.opacity = opacity;
                }
            });
        }
    }, [calculateTransformations]);

    // 4. Montaje inicial
    useEffect(() => {
        getApi("getRank/").then(data => {
            let final = JSON.parse(JSON.stringify(data.rank).replace("[{", '[{"row_id":-1,"nombre":"","casa":"","pts":"0"},{"row_id":0,"nombre":"","casa":"","pts":"0"},{'))
            setMenuItems(final);
        });
        setIsMounted(true);
        const timeoutId = setTimeout(updateScales, 500);
        return () => clearTimeout(timeoutId);
    }, [updateScales]);

    return (
        <div className="Sesion" style={{ maxWidth: "500px", margin: 'auto' }}>
            <div style={{ textAlign: "center" }}>
                <img src={logo} width={100} style={{ marginBottom: 10,marginTop: 100}}></img>
                <p>Competidores de la <br></br>Gran Copa de las Casas</p>
                <img src={separador} width={250} style={{ marginBottom: 10 }}></img>
            </div>

            <div
                ref={listRef}
                style={styles.container} // Aplicamos la perspectiva al contenedor
            >
                <Virtuoso
                    onScroll={updateScales}
                    data={menuItems}
                    overscan={5}
                    style={{ height: "100%" }}
                    itemContent={(index, item) => (
                        
                        <div
                            className="scroll-item"
                            style={styles.item}
                            ref={el => {
                                if (el) {
                                    itemRefs.current[item.nombre] = el;
                                } else {
                                    delete itemRefs.current[item.nombre];
                                }
                                if (isMounted) {
                                    //updateScales();
                                }
                            }}
                        >
                            {item.row_id > 0 ? <div class="row">
                                <div class="col-1" >
                                    <div>
                                        #{item.row_id}
                                    </div>
                                </div>
                                <div class="col-9" style={{ fontSize: 12 }}>
                                    <div class="row">
                                        <div class="col-2">
                                            <img src={casaIc(item.casa)} width={20} style={{ marginLeft: 20 }}></img>
                                        </div>
                                        <div class="col-10">
                                            <div>
                                                {item.nombre}
                                            </div>
                                            <div>
                                                <strong>{item.pts}pts.</strong>
                                            </div>


                                        </div>
                                    </div>


                                </div>
                                <div class="col-2" >
                                    <div>
                                        <img src={medalla(item.row_id)} width={20} style={{ marginLeft: 20 }}></img>
                                    </div>
                                </div>
                            </div> :
                                item.row_id == 0 ?
                                    <div style={{ textAlign: "center" }}>

                                        {/*    <img src={logo} width={100} style={{marginBottom:10}}></img>
                                        <p>Competidores de la <br></br>Gran Copa de las Casas</p>
                                        <img src={separador} width={250} style={{marginBottom:10}}></img>*/}
                                    </div>
                                    :
                                    <div>

                                    </div>
                            }
                        </div>
                    )}
                />
            </div>
        </div>
    );
};

export default ScaleMenu3DComponent;